var HHS = {};

HHS.baseUrl = window.location.protocol + '//' + window.location.hostname;
// ----- Console log

// c.f. http://paulirish.com/2009/log-a-lightweight-wrapper-for-consolelog/
window.log = function log() {

	log.history = log.history || [];
	log.history.push(arguments);

	if(this.console){
		items = Array.prototype.slice.call(arguments);
		if (items.length == 1)
		{
			console.log( 'HHS: ', Array.prototype.slice.call(arguments).shift() );
		}
		else
		{
			console.group('HHS: ', items.shift());
			for (var i=0; i < items.length; i++)
			{
				console.log(items[i]);
			}
			console.groupEnd();
		}

	}

};


$(function bootstrap() {
	log("Here we go!", "Booting up.", HHS);
});